import G from "@babel/runtime/helpers/esm/objectSpread2";
import J from "@babel/runtime/helpers/esm/objectWithoutProperties";
import Q from "@babel/runtime/helpers/esm/slicedToArray";
import { sstyled as V } from "@semcore/utils/lib/core/index";
import x from "react";
import X from "classnames";
import { sstyled as Y } from "@semcore/core";
import Z from "@semcore/utils/lib/propsForElement";
import I from "@semcore/utils/lib/logger";
import { getAutoOrScaleIndent as m } from "../utils.mjs";
var tt = ["tag", "className", "style", "scaleIndent", "display", "boxSizing", "inline", "flex", "w", "h", "wMin", "wMax", "hMin", "hMax", "m", "mt", "mb", "my", "ml", "mr", "mx", "p", "pt", "pb", "py", "pl", "pr", "px", "css", "position", "top", "left", "bottom", "right", "zIndex"], it = (
  /*__reshadow_css_start__*/
  (V.insert(
    /*__inner_css_start__*/
    ".___SBoxSizing_12ntt_gg_{box-sizing:border-box}.___SBoxInline_12ntt_gg_{display:inline-block}",
    "12ntt_gg_"
  ), {
    __SBoxSizing: "___SBoxSizing_12ntt_gg_",
    __SBoxInline: "___SBoxInline_12ntt_gg_"
  })
);
function et(t) {
  return Object.entries(t).reduce(function(e, i) {
    var o = Q(i, 2), r = o[0], a = o[1];
    return a !== void 0 && (e[r] = a), e;
  }, {});
}
function n(t) {
  if (typeof t != "number")
    return t;
  if (t < 1)
    return "".concat(100 * t, "%");
  if (t >= 1)
    return "".concat(t, "px");
}
function mt(t, e) {
  return et({
    display: t.display,
    width: n(t.w),
    height: n(t.h),
    minWidth: n(t.wMin),
    maxWidth: n(t.wMax),
    minHeight: n(t.hMin),
    maxHeight: n(t.hMax),
    position: t.position,
    top: n(t.top),
    left: n(t.left),
    bottom: n(t.bottom),
    right: n(t.right),
    flex: t.flex,
    zIndex: t.zIndex,
    margin: m(t.m, e),
    marginTop: m(t.mt, e) || m(t.my, e),
    marginBottom: m(t.mb, e) || m(t.my, e),
    marginLeft: m(t.ml, e) || m(t.mx, e),
    marginRight: m(t.mr, e) || m(t.mx, e),
    padding: m(t.p, e),
    paddingTop: m(t.pt, e) || m(t.py, e),
    paddingBottom: m(t.pb, e) || m(t.py, e),
    paddingLeft: m(t.pl, e) || m(t.px, e),
    paddingRight: m(t.pr, e) || m(t.px, e)
  });
}
function yt(t, e) {
  var i = t, o = i.tag, r = o === void 0 ? "div" : o, a = i.className, _ = i.style, g = i.scaleIndent, l = g === void 0 ? 4 : g, y = i.display, h = i.boxSizing, u = i.inline, b = i.flex, c = i.w, S = i.h, M = i.wMin, v = i.wMax, w = i.hMin, B = i.hMax, s = i.m, z = i.mt, p = i.mb, N = i.my, T = i.ml, j = i.mr, F = i.mx, O = i.p, R = i.pt, W = i.pb, $ = i.py, k = i.pl, A = i.pr, H = i.px, f = i.css, L = i.position, P = i.top, E = i.left, K = i.bottom, U = i.right, q = i.zIndex, d = J(i, tt), C = x.useMemo(function() {
    return mt(t, l);
  }, [l, y, c, S, M, v, w, B, b, s, z, p, N, T, j, F, O, R, W, $, k, A, H, L, P, E, K, U, q]);
  I.warn(f !== void 0, "The 'css' property is deprecated, use 'style'", d["data-ui-name"] || "Box");
  var D = Y(it);
  return r === x.Fragment ? [x.Fragment, {
    children: t.children
  }] : [r, G({
    ref: e,
    className: X(D.cn("SBox", {
      SBoxSizing: h,
      SBoxInline: u
    }).className, a) || void 0,
    style: Object.assign({}, _, f, C),
    "data-ui-name": "Box"
  }, Z(d, r))];
}
export {
  yt as default,
  et as removeUndefinedKeys
};
